
// import React, { useState } from 'react';
// import axios from 'axios';
// import { useParams, useNavigate } from 'react-router-dom';
// import AppFooter from './AppFooter';
// import { toast } from 'react-toastify';
// import { FaTimes } from 'react-icons/fa';

// export default function PasswordResetForm() {
//   const { tenant } = useParams();
//   const [email, setEmail] = useState('');
//   const [busy, setBusy] = useState(false);
//   const navigate = useNavigate();
//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   const postWithFallback = async (path) => {
//     // Try /api/users first, then /api
//     const urls = [`${baseUrl}/api/users${path}`, `${baseUrl}/api${path}`];
//     let lastErr;
//     for (const url of urls) {
//       try {
//         return await axios.post(url, { email, tenant });
//       } catch (e) {
//         lastErr = e;
//         if (e?.response?.status !== 404) throw e; // only fall back on 404
//       }
//     }
//     throw lastErr;
//   };

//   const submit = async (e) => {
//     e.preventDefault();
//     if (!email) return;
//     setBusy(true);
//     try {
//       const { data } = await postWithFallback('/password-reset');
//       toast.success(data?.message || 'If that email exists, we sent a reset link.');
//     } catch (err) {
//       const msg = err?.response?.data?.message || 'If that email exists, we sent a reset link.';
//       toast.info(msg);
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <div className="max-w-md mx-auto p-4">
//       <h2 className="hdr hdr--primary hdr--lg">Reset Password</h2>
//       <form onSubmit={submit} className="space-y-4">
//         <input
//           type="email"
//           placeholder="Your email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           className="w-full border p-2"
//           required
//         />
//         <button
//           type="submit"
//           disabled={busy}
//           className="btn btn-primary text-white px-4 py-2 rounded"
//         >
//           {busy ? 'Sending…' : 'Send Reset Email'}
//         </button>
//       </form>

//       <AppFooter
//         buttons={[
//           {
//             icon: <FaTimes />,
//             label: 'Cancel',
//             onClick: () => navigate(-1),
//           },
//         ]}
//       />
//     </div>
//   );
// }


import React, { useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import AppFooter from './AppFooter';
import { toast } from 'react-toastify';
import { FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function PasswordResetForm() {
  const { t } = useTranslation();
  const { tenant } = useParams();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  const postWithFallback = async (path) => {
    // Try /api/users first, then /api
    const urls = [`${baseUrl}/api/users${path}`, `${baseUrl}/api${path}`];
    let lastErr;
    for (const url of urls) {
      try {
        return await axios.post(url, { email, tenant });
      } catch (e) {
        lastErr = e;
        if (e?.response?.status !== 404) throw e; // only fall back on 404
      }
    }
    throw lastErr;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await postWithFallback('/password-reset');
      toast.success(data?.message || t('auth.resetEmailSentMessage'));
    } catch (err) {
      const msg = err?.response?.data?.message || t('auth.resetEmailSentMessage');
      toast.info(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-4" style={{ paddingTop: '80px', paddingBottom: '120px' }}>
      <h2 className="hdr hdr--primary hdr--lg">{t('auth.resetPasswordTitle')}</h2>
      <form onSubmit={submit} className="space-y-4">
        <input
          type="email"
          placeholder={t('auth.emailPlaceholder')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border p-2"
          required
        />
        <button
          type="submit"
          disabled={busy}
          className="btn btn-primary text-white px-4 py-2 rounded"
        >
          {busy ? t('auth.sendingButton') : t('auth.sendResetEmailButton')}
        </button>
      </form>

      <AppFooter
        buttons={[
          {
            icon: <FaTimes />,
            label: t('common.cancel'),
            onClick: () => navigate(-1),
          },
        ]}
      />
    </div>
  );
}